/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IMfrmNotificationsViewProps } from './mfrm-notifications';

export default (props: IMfrmNotificationsViewProps) => {
    const { notification, pageScrolled } = props;
    const notificationClass = props.config.className || 'msc-notification-wrap';
    const pageScrollClass = pageScrolled ? 'msc-notification-wrap--fixed' : '';

    return <Node className={`${pageScrollClass} ${notificationClass}`}>{notification}</Node>;
};
